import { mapArtistType, useFindArtistSuspense } from '@api';
import { NavigateBackButton } from '@common';
import { Group } from '@mantine/core';
import { Route } from 'src/routes/_rootLayout/artists/$id';

export const ArtistDetailsHeader: React.FC = () => {
  const { id } = Route.useParams();
  const { data: artist } = useFindArtistSuspense(id, {
    query: { select: (data) => mapArtistType(data.data) },
  });

  return (
    <Group gap="xs">
      <NavigateBackButton to="/artists" />
      {artist.name}
    </Group>
  );
};
